import { AfterViewInit, Component, computed, effect, inject, OnInit, signal, TemplateRef, untracked, viewChild } from '@angular/core'
import { HttpParams } from '@angular/common/http'
import { EMPTY, forkJoin, from } from 'rxjs'
import { catchError, finalize, switchMap, tap } from 'rxjs/operators'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ITabOwnerClaim } from 'src/app/features/shared/central-page/models/tab-data-template'
import { ProgressBarService } from 'src/app/features/shared/progress-bar/progress-bar.service'
import { ScreenLockService } from 'src/app/infrastructure/services/loading-services/screen-lock.service'
import { photoMainUpload$ } from 'src/app/features/image/functions/photo-main-upload.function'
import { ButtonActionComponent } from '../../shared/controls/container/button-action/button-action.component'
import { httpParamKey } from 'src/app/infrastructure/services/request-services/models/http-param-name'
import { IImageListData, imageListData } from '../../image/models/image-list-data'
import { IInvitationUserDto, invitationUserDto } from 'src/assets/common/models/invitation-user-dto.g'
import { invitationStatus } from 'src/assets/common/enums/invitation-status.g'
import { UserPhotoTablistComponent } from '../components/user-photo-tablist/user-photo-tablist.component'

import { AccountCompactComponent } from '../account/components/account-compact/account-compact.component'
import { AccountDetailsComponent } from '../account/components/account-details/account-details.component'
import { AccountEditComponent } from '../account/components/account-edit/account-edit.component'
import { AccountFormModelService } from '../services/account-form-model.service'
import { AccountPageService } from '../services/account-page.service'
import { ActivatedRouteService } from 'src/app/infrastructure/services/route-service/activated-route.service'
import { AdminPageService } from 'src/app/admin/services/admin-page.service'
import { ButtonNavigationComponent } from '../../shared/controls/container/button-navigation/button-navigation.component'
import { CentralPageModule } from '../../shared/central-page/central-page.module'
import { ChatListService } from '../../chat/services/chat-list.service'
import { ChatTablistComponent } from '../../chat/components/chat-tablist/chat-tablist.component'
import { MessageTablistComponent, messageListContext } from 'src/app/features/message/components/message-tablist/message-tablist.component';
import { messageListData } from 'src/app/features/message/models/message-list-data';
import { MessageListService } from 'src/app/features/message/services/message-list.service';
import { chatListData } from '../../chat/models/chat-list-data'
import { _CentralPageService } from '../../shared/central-page/services/_central-page.service'
import { DomainTablistComponent } from '../../domain/components/domain-tablist/domain-tablist.component'
import { FooterService } from '../../shared/footer/footer.service'
import { FunctionMemberListService } from '../../function-member/services/function-member-list.service'
import { FunctionMemberTablistComponent } from '../../function-member/components/function-member-tablist/function-member-tablist.component'
import { functionMemberListView } from '../../function-member/models/function-member-list-view';
import { IFooterData } from '../../shared/footer/models/footer-data'
import { IHeaderData } from '../../shared/header/models/header-data'
import { IPageData } from 'src/app/infrastructure/services/page-services/models/page-data'
import { CLAIM_PAGE_DETAILS, ROUTE_PAGE as ROUTE_PAGE } from 'src/app/infrastructure/injection-tokens/PAGE-NAME'
import { SectionButtonCancel } from '../../shared/central-page/components/button-blocks/models/section-button-cancel'
import { SectionButtonDelete } from '../../shared/central-page/components/button-blocks/models/section-button-delete'
import { SectionButtonEdit } from '../../shared/central-page/components/button-blocks/models/section-button-edit'
import { SectionButtonSave } from '../../shared/central-page/components/button-blocks/models/section-button-save'
import { SharedModule } from '../../shared/shared.module'
import { TabListService } from '../../shared/central-page/services/tab-list.service'
import { _TabPageService } from '../../shared/central-page/services/_tab-page.service'
import { _FormModelService } from 'src/app/infrastructure/services/model-services/_form-model.service'
import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service'
import { _TabPageRouteComponent } from 'src/app/infrastructure/components/route-components/_tab-page-route-component'
import { claimName } from 'src/assets/common/enums/claim-name.g'
import { claimPage } from 'src/app/infrastructure/models/claim-page'
import { DomainUserListData, domainUserListData } from '../../domain-user/models/domain-user-list-data'
import { domainUserListDto } from 'src/assets/common/models/domain-user-list-dto.g'
import { functionMemberListData } from '../../function-member/models/function-member-list-data'
import { pageLayout, TPageLayout } from 'src/app/infrastructure/models/page-layout'
import { pageMode, TPageMode } from 'src/app/infrastructure/models/page-mode'
import { routePage, TRoutePage } from 'src/app/infrastructure/services/route-service/models/route-page'
import { tabName } from 'src/app/infrastructure/services/page-services/models/tab-name'
import { ITabDataTemplate, TabDataTemplate } from '../../shared/central-page/models/tab-data-template'
import { TabPageStorageService } from '../../shared/storage/services/storage-services/tab-page-storage.service'
import { pageName } from 'src/assets/common/enums/page-name.g'
import { pageSectionName } from 'src/app/infrastructure/services/page-services/models/page-section-name'
import { photoName } from 'src/app/infrastructure/models/image-type'
import { pollWhilePending } from 'src/app/infrastructure/functions/poll-while-pending.function'
import { requestName } from 'src/assets/common/enums/request-names.g'
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { IUserDto, userDto } from 'src/assets/common/models/user-dto.g'
import { API_SUPPRESS_PROGRESS_HEADER } from 'src/app/infrastructure/services/api-service/api.service'
import { IAccountForm } from '../account/models/account-form'

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: [
        '../../shared/central-page/central-page.scss',
        './home.component.scss'
    ],
    standalone: true,
    imports: [
        CentralPageModule,
        SharedModule,

        AccountCompactComponent,
        AccountDetailsComponent,
        AccountEditComponent,

        ButtonActionComponent,
        ButtonNavigationComponent,
        ChatTablistComponent,
        MessageTablistComponent,
        DomainTablistComponent,
        FunctionMemberTablistComponent,
        UserPhotoTablistComponent,
    ],
    providers: [
        {provide: ROUTE_PAGE, useValue: routePage.home},
        // Vroege auth-pagina-registratie voor de tab-footer-Edit/Delete-knoppen — zie
        // _TabPageRouteComponent._ngOnInit en DomainComponent (zelfde patroon, eerst daar gefixt).
        {provide: CLAIM_PAGE_DETAILS, useValue: pageSectionName.accountDetails},
        ActivatedRouteService,
        FooterService,
        TabPageStorageService,
        TabListService,
        {provide: _CentralPageService, useExisting: TabListService},
        {provide: _TabPageService, useExisting: TabListService},

        {provide: _FormModelService, useClass: AccountFormModelService},
        {provide: _PageService, useClass: AccountPageService},

        AdminPageService,
        ChatListService,
        MessageListService,
        FunctionMemberListService,
    ]
})
export class HomeComponent
    extends _TabPageRouteComponent<IUserDto, IAccountForm>
    implements OnInit, AfterViewInit
{
    private readonly __adminPageService = injectRequired(AdminPageService);
    private readonly __progressBarService = injectRequired(ProgressBarService)
    private readonly __screenLockService = injectRequired(ScreenLockService)

    // Services
    override readonly userClaimService = this._applicationUserService;
    override readonly activatedRouteService = this._activatedRouteService;
    override readonly centralPageService = this._centralPageService;
    override readonly footerService = this._footerService;
    override readonly formModelService = this._formModelService;
    override readonly loadingPageService = this._loadingPageService;
    override readonly loadingService = this._loadingService;
    override readonly pageService = this._pageService;
    override readonly reloadService = this._reloadService;
    override readonly tabListService = this._tabListService;
    override readonly notificationService = this._notificationService;
    override readonly apiService = this._apiService;

    // Data
    override headerData: Partial<IHeaderData> = {
        sideBlockLeft_noClick: true,
    };
    override footerData: Partial<IFooterData> = {};
    override returnPage: IPageData | null = null;
    override btnCancelData = SectionButtonCancel.create();
    override btnDeleteData = SectionButtonDelete.create({tooltip: 'delete account'});
    override btnEditData = SectionButtonEdit.create({tooltip: 'edit account'});
    override btnSaveData = SectionButtonSave.create({tooltip: 'save account'});
    override isStartPage = true;
    override pageCreate_name: TRoutePage | null = null;
    override pageCurrent_name: TRoutePage = routePage.home;
    override pageLayout: TPageLayout = pageLayout.tabPage;
    override pageMode_initial: TPageMode = pageMode.tabPage;
    // pageSection*_name niet meer nodig: account-details/account-edit provide'n CLAIM_PAGE zelf.
    override photo_show = true;

    // Templates
    override readonly template_details$$ = this._template_details_viewChild$$;
    override readonly template_edit$$ = this._template_edit_viewChild$$;
    override readonly template_footerLeft$$ = this._template_footerLeft_viewChild$$;
    override readonly template_compact$$ = this._template_compact_default$$;

    // Openstaande domain-uitnodigingen voor het eigen e-mailadres (invitation-flow):
    // accepteren zet de status op Accepted, waarna de domeineigenaar nog moet goedkeuren.
    private __pendingInvitations$$ = signal<IInvitationUserDto[]>([])
    pendingInvitations$$ = this.__pendingInvitations$$.asReadonly()
    invitationKeys = invitationUserDto
    invitationStatus = invitationStatus

    // Twee losse "geen toegankelijk domain"-situaties (zie __onboarding_check), met elk een eigen
    // UI-behandeling:
    //
    // 1. __isOnboarding$$ — helemaal nog geen DomainUser-record én geen openstaande uitnodiging
    //    (nieuwe gebruiker). AccountDetails-only zou hier een doodlopend pad zijn: je kunt daar geen
    //    domain aanmaken. Home blijft dus gewoon in tabPage-modus, maar sourceList$$ toont alleen de
    //    domains-tab (met diens eigen bestaande toevoeg-knop in de footer) — de enige zinvolle actie.
    // 2. __isBlockedDomains$$ — wél DomainUser-record(s), maar geen enkele actief (bv. domain zelf
    //    inactief, of de eigen DomainUser-lidmaatschap verlopen/verwijderd). Hier helpt een nieuw
    //    domain aanmaken niet (het bestaande lidmaatschap is geblokkeerd, geen tekort) — sourceList$$
    //    wordt leeg (hieronder) en __footerLock_sync verbergt alle footer-acties, zodat alleen het
    //    eigen account te bekijken is totdat de blokkade is opgeheven. hasList$$ (TabListService)
    //    schakelt bij een lege sourceList vanzelf naar pageMode.detailsPage, waarmee AccountDetails
    //    zichtbaar wordt.
    // 3. __noActiveDomain$$ — wél records en niet geblokkeerd, maar geen enkel lidmaatschap actief
    //    (bv. alle periodes beëindigd: alleen-lezen). Domains en FunctionMembers blijven als historie
    //    staan; de profile-photos-tab verdwijnt, zodat de fotopool zonder actief (eigen of gast-)domain
    //    niet kan groeien. De hoofdfoto blijft via AccountDetails te wijzigen.
    private __isOnboarding$$ = signal<boolean>(false)
    private __isBlockedDomains$$ = signal<boolean>(false)
    private __noActiveDomain$$ = signal<boolean>(false)


    template_tab0$$ = viewChild<TemplateRef<any>>('template_tab0')
    template_tab1$$ = viewChild<TemplateRef<any>>('template_tab1')
    template_tab2$$ = viewChild<TemplateRef<any>>('template_tab2')
    template_tab3$$ = viewChild<TemplateRef<any>>('template_tab3')
    template_messages$$ = viewChild<TemplateRef<any>>('template_messages')

    readonly messageListContext = messageListContext;

    // Eigen guid van de ingelogde User — nodig als httpParamKey.key op de Photos-tab hieronder
    // (ImageTablistComponent._list_get$ leest die key voor de guid-queryparam van Photo/list; zonder
    // deze key zou de tab op een lege/ambient guid draaien i.p.v. de eigen UserPhoto-foto's).
    protected readonly _ownGuid$$ = computed<string | null>(() => this.resolver$$()?.[userDto.guid] ?? null)
    // Home = altijd het eigen account: eigenaar voor de generieke hoofdfoto-upload-claim (EntityOwner,
    // BtnMainPhotoEdit_Show op AccountDetails — zie _TabPageService.photoCanUpload$$).
    private __photoOwnerClaim$$ = computed<ITabOwnerClaim>(() => ({ kind: 'entity', ownerGuid: this._ownGuid$$() }))

    // Forceert de footer-acties uit zodra __isBlockedDomains$$ aan staat. Getrackt op pageMode$$
    // (i.p.v. alleen __isBlockedDomains$$): AccountDetailsComponent zet zijn eigen footerData
    // (hideSideBlockLeft/-Right: false) pas bij mount, en dat mount-moment volgt zelf pas ná
    // __isBlockedDomains$$ (via de lege sourceList$$ hieronder -> TabListService schakelt naar
    // pageMode.detailsPage). Zonder de pageMode$$-dependency zou deze effect vóór die mount al
    // afvuren en meteen weer overschreven worden.
    //
    // Uitzondering: het admin-gear-knopje (links) blijft zichtbaar voor een administrator zonder
    // eigen toegankelijke domains — die moet bij AdminPanel kunnen komen. btnAdminPanel_show()
    // wordt hier bewust getrackt (niet untracked): userClaims$$ kan later in golven binnenkomen
    // (zie ApplicationUserService.claim_check), en zonder deze dependency zou een admin die pas ná
    // deze eerste run zijn claims krijgt de knop alsnog gemist hebben.
    private __footerLock_sync = effect(() => {
        const __locked = this.__isBlockedDomains$$()
        this._centralPageService.pageMode$$()
        if (!__locked) return

        const __isAdmin = this.btnAdminPanel_show()

        untracked(() => {
            this._centralPageService.btnEditData_set({ hide: true })
            this._centralPageService.btnDeleteData_set({ hide: true })
            this._centralPageService.btnSaveData_set({ hide: true })
            this._centralPageService.btnCancelData_set({ hide: true })
            this._footerService.footerData_set({ hideSideBlockLeft: !__isAdmin, hideSideBlockRight: true })
        })
    })

    override sourceList$$ = computed<ITabDataTemplate[]>(() => {
        // Geblokkeerd (wél domains, geen enkele actief): geen enkele tab tonen, zie
        // __isBlockedDomains$$ hierboven — TabListService valt dan terug op pageMode.detailsPage
        // (AccountDetails).
        if (this.__isBlockedDomains$$()) return []

        const __domainsTab = new TabDataTemplate({
            // tabName.domains: dezelfde Page als de inhoud van deze tab (DomainTablistComponent, met
            // LIST_KIND_NAME = tabName.domains). De Page_Read-claim op Domains is de autorisatie voor
            // zowel deze tab als /api/DomainUser/list-from-user (PageNameEnum.Domains, zie
            // DomainUserController.ListFromUser).
            name: tabName.domains,
            label: 'domains',
            searchFields: [
                domainUserListData.displayName,
                domainUserListData.domain_name,
                domainUserListData.lastVisit,
                domainUserListData.active,
            ],
            // Default: actief eerst — zelfde patroon als DomainComponent's domainUsers-tab
            // (sortFields: [{ field: domainUserData.active, direction: 'desc' }]). Een verlopen
            // toegangsperiode (membershipInactive) toont de rij nu gedimd i.p.v. hem te verbergen —
            // zie FunctionMemberController/DomainUserController voor de harde poort die read-only
            // claims daadwerkelijk afdwingt; dit is puur de lijst-weergave.
            sortFields: [
                { field: domainUserListData.active, direction: 'desc' },
            ],
            requestName: requestName.listFromUser,
            templateList: this.template_tab0$$()
        })

        // Onboarding (nog geen enkel domain/uitnodiging): alleen de domains-tab, met zijn eigen
        // toevoeg-knop in de footer — functions/photos hebben zonder domain toch niets te tonen.
        if (this.__isOnboarding$$()) return [__domainsTab]

        const __functionMembersTab = new TabDataTemplate({
            name: tabName.functionMembers,
            label: 'function members',
            listView: functionMemberListView.home,
            searchFields: [functionMemberListData.function_label, functionMemberListData.domain_name, functionMemberListData.project_name, functionMemberListData.active],
            // Actief eerst — zelfde patroon als de domains-tab hierboven.
            sortFields: [
                { field: functionMemberListData.active, direction: 'desc' },
            ],
            requestName: requestName.listFromUser,
            templateList: this.template_tab1$$()
        })

        // Centraal chatoverzicht: open chats over alle domains (ChatController.Mine). Het label blijft vast: een
        // teller erin zou sourceList$$ bij elke poll opnieuw laten opbouwen; het aantal ongelezen staat in de header
        // (badge) en per rij.
        const __chatsTab = new TabDataTemplate({
            name: tabName.homeChats,
            label: 'chats',
            searchFields: [chatListData.subject, chatListData.domain_name, chatListData.project_name, chatListData.lastMessage_senderName, chatListData.lastMessage_body],
            sortFields: [
                { field: chatListData.lastMessageOn, direction: 'desc' },
            ],
            requestName: requestName.mine,
            templateList: this.template_tab3$$()
        })

        // Centraal berichtenoverzicht: ontvangen berichten over alle domains (MessageController.Mine).
        const __messagesTab = new TabDataTemplate({
            name: tabName.homeMessages,
            label: 'messages',
            searchFields: [
                messageListData.subject,
                messageListData.sender_name,
                messageListData.audience_names,
                messageListData.project_name,
            ],
            // Default: nieuwste bericht bovenaan (zelfde volgorde als de backend).
            sortFields: [
                { field: messageListData.sentOn, direction: 'desc' },
            ],
            requestName: requestName.mine,
            templateList: this.template_messages$$()
        })

        // Geen actief domain: domains + functions (en lopende chats/berichten) blijven als historie, geen fotolijst (zie __noActiveDomain$$).
        if (this.__noActiveDomain$$()) return [__domainsTab, __functionMembersTab, __chatsTab, __messagesTab]

        return [
            __domainsTab,
            __functionMembersTab,
            __chatsTab,
            __messagesTab,
            new TabDataTemplate({
                name: tabName.userPhotos,
                label: 'profile photos',
                httpParams: new HttpParams().set(httpParamKey.key, this._ownGuid$$() ?? ''),
                searchFields: [imageListData.description, imageListData.datum, imageListData.maandOmschrijving, imageListData.jaartal],
                requestName: 'list-from-user-photo',
                templateList: this.template_tab2$$()
            }),
        ]
    })

    constructor() {
        super()
        // Home heeft geen domain-scope: de tab-autorisatie moet op de null-scope claims controleren, ook als
        // routeKeys een domain-fallback van een eerder bezoek (bv. de Domain-pagina) meedraagt.
        this._tabListService.tabAuth_noDomainScope = true
        this._tabListService.photoType_set(photoName.userPhoto)
        this._tabListService.photoOwnerClaimSource_set(this.__photoOwnerClaim$$)

        // Upload via de hoofdfoto-box: in de eigen User-fotopool en meteen als Home-hoofdfoto
        // (User.PhotoFileBoxId) koppelen — zelfde twee-staps keten als de andere hoofdfoto-pagina's.
        this._tabListService.photoUpload$
            .pipe(
                switchMap(file => {
                    this.__screenLockService.add()
                    return photoMainUpload$(this._apiService, this.__progressBarService, file, photoName.userPhoto, this._ownGuid$$() ?? undefined, null).pipe(
                        tap(dto => {
                            this._tabListService.mainPhoto_change(dto.photoThumbDto?.guid ?? null)
                            this._tabListService.tabList_setRefresh(true)
                            this._tabListService.photoListChanged_emit()
                        }),
                        catchError(() => EMPTY),
                        finalize(() => this.__screenLockService.remove()),
                    )
                }),
                takeUntilDestroyed(),
            )
            .subscribe()

        // Zolang er voor deze user nog een eigen openstaande uitnodiging is (pending/accepted, zie
        // list-from-user), kan de domeineigenaar ondertussen goedkeuren/intrekken — poll dan
        // periodiek zodat dat hier vanzelf zichtbaar wordt i.p.v. handmatig te moeten verversen.
        // Stopt vanzelf zodra er niets meer openstaat.
        pollWhilePending(
            () => this.pendingInvitations$$().length > 0,
            () => this.__invitations_reload(),
        )
    }

    override ngOnInit(): void {
        super._ngOnInit()
        this.__onboarding_check()
    }

    // Achtergrond-herlaad (poll, en na accepteren): geen footer-progressbar.
    private __invitations_reload(): void {
        from(this._apiService.GET('/api/Invitation/list-from-user', {
            headers: { [API_SUPPRESS_PROGRESS_HEADER]: 'true' },
        }))
            .subscribe({
                next: r => this.__pendingInvitations$$.set(((r.data as any)?.list ?? []) as IInvitationUserDto[]),
                error: () => { /* afgehandeld door ErrorReportingService */ },
            })
    }

    invitation_accept(invitation: IInvitationUserDto): void {
        from(this._apiService.POST('/api/Invitation/accept', {
            body: { guid: invitation[this.invitationKeys.guid] } as any,
        }))
            .subscribe({
                // openapi-fetch verwerpt de Promise niet bij een non-ok response — next vuurt dus
                // ook bij een serverfout. r.error onderscheidt dat van een echt geslaagde acceptatie;
                // ErrorReportingService toont de foutmelding zelf al globaal.
                next: r => {
                    if (r.error) return

                    this._notificationService.pushNotification({
                        severity: 'info',
                        title: 'Uitnodiging geaccepteerd',
                        text: `De eigenaar van ${invitation[this.invitationKeys.domain_Name]} moet je toegang nog goedkeuren; je ontvangt een e-mail zodra dat gebeurd is.`,
                    })
                    this.__invitations_reload()
                },
                error: () => { /* afgehandeld door ErrorReportingService */ },
            })
    }

    private __onboarding_check(): void {
        forkJoin({
            domains: from(this._apiService.GET('/api/DomainUser/list-from-user', {})),
            invitations: from(this._apiService.GET('/api/Invitation/list-from-user', {})),
        }).subscribe({
            next: ({ domains, invitations }) => {
                const __invitationList = ((invitations.data as any)?.list ?? []) as IInvitationUserDto[]
                this.__pendingInvitations$$.set(__invitationList)

                const __domainList = ((domains.data as any)?.list ?? []) as any[]
                if (__domainList.length === 0) {
                    // Nog geen enkel DomainUser-record: pas de onboarding-stand toe zolang er ook
                    // geen openstaande uitnodiging is (die brengt vanzelf een eerste domain).
                    if (__invitationList.length === 0) this.__isOnboarding$$.set(true)
                    return
                }

                // Wél records, maar controleer of er minstens één TOEGANKELIJK lidmaatschap tussen zit.
                // Bewust op accessBlocked (Deleted/Domain.Inactive/User.Inactive) i.p.v. het bredere
                // inactive: een DomainUser met uitsluitend een verstreken EndDate is niet geblokkeerd
                // meer, alleen read-only (zie DomainUser.AccessBlocked/Inactive backend-side) — die
                // moet hier gewoon zijn domains-tab te zien krijgen i.p.v. de AccountDetails-lockdown.
                const __hasActiveDomain = __domainList.some(d => d[domainUserListDto.accessBlocked] !== true)
                if (!__hasActiveDomain) this.__isBlockedDomains$$.set(true)

                // Toegankelijk maar alleen-lezen: zelfde active-regel als het dimmen in de domains-tab
                // (DomainUserListData.active — einddatum, backend-inactive, 2FA-vereiste).
                if (!__domainList.some(d => DomainUserListData.create(d)?.[domainUserListData.active])) this.__noActiveDomain$$.set(true)
            },
            error: () => { /* afgehandeld door ErrorReportingService */ },
        })
    }

    override emit_onEscape(): void {
        super._emit_onEscape()
    }

    override emit_onPageLoaded(): void {
        super._emit_onPageLoaded()
    }

    btnAdminPanel_show(): boolean {
        const __routeKeys = this.activatedRouteService?.routeKeys ?? null;

        return this._applicationUserService.claim_check(pageName.adminPanelDetails, __routeKeys, claimName.page_Read)
    }

    pageAdmin_goto() {
        this.__adminPageService.pageRoute_goto()
    }

    // Eigen-hoofdfoto gewijzigd via de Photos-tab (UserPhotoTablistComponent.onOwnMainPhotoChanged):
    // de PATCH is al gedaan, hier alleen de banner-override zetten zodat Home meteen de nieuwe foto
    // toont zonder een nieuwe route-resolve af te wachten (Home heeft geen eigen nav-history-entry,
    // dus mainPhoto_change patcht hier alleen de banner — zie TabListService.mainPhoto_change).
    // Deze User-foto is óók de fallback-hoofdfoto voor elke DomainUser zonder eigen domain-specifieke
    // profielfoto (zie domain-user-data.ts) — userPhotoGuid_propagate werkt die drawer-entries
    // (navCategory.domainUsers, photoIsUserFallback) apart bij, want ze horen niet bij déze pagina
    // (category+guid) en de generieke mainPhoto_change-flow bereikt ze dus niet.
    emit_ownMainPhotoChanged(item: IImageListData | null): void {
        const __guid = item?.thumbGuid ?? null
        this._tabListService.mainPhoto_change(__guid, item?.version ?? null)
        this._navHistoryService.userPhotoGuid_propagate(__guid)
    }

    override ngAfterViewInit(): void {
        super._ngAfterViewInit()
    }
}
